import { useEffect, useState } from "react";
import api from "@/lib/api";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { exportCSV } from "@/lib/exports";
import { ExportBtn } from "@/components/dashboard/ExportBtn";

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const ChannelMonth = () => {
  const [month, setMonth] = useState(String(new Date().getMonth() + 1));
  const [data, setData] = useState([]);
  useEffect(() => { api.get(`/analysis/channel-month?month=${month}`).then((r) => setData(r.data)).catch(() => {}); }, [month]);
  return (
    <div data-testid="channel-month-chart" className="bg-[#1E293B] border border-[#334155] rounded-xl p-4 sm:p-5">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <div>
          <h3 className="text-base sm:text-lg font-bold" style={{ fontFamily: "Outfit, sans-serif" }}>Channel Deliveries — Same Month, All Years</h3>
          <p className="text-[11px] text-slate-400">B2C = counter sales · B2B = subdealer (ASC) sales</p>
        </div>
        <div className="flex items-center gap-2">
          <Select value={month} onValueChange={setMonth}>
            <SelectTrigger data-testid="channel-month-select" className="w-36 h-9 bg-[#0B0F17] border-[#334155] text-slate-100 text-xs">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-[#111827] border-[#334155] text-slate-100">
              {MONTHS.map((m, i) => <SelectItem key={m} value={String(i + 1)}>{m}</SelectItem>)}
            </SelectContent>
          </Select>
          <ExportBtn onCSV={() => exportCSV(data, `channel-${MONTHS[month - 1]}`)} />
        </div>
      </div>
      <div className="h-72">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 5, right: 10, left: -15, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
            <XAxis dataKey="year" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} />
            <Tooltip contentStyle={{ background: "#111827", border: "1px solid #334155", borderRadius: 8, fontSize: 12 }} labelStyle={{ color: "#e2e8f0" }} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="b2c" name="B2C (Counter)" fill="#10b981" radius={[4, 4, 0, 0]} />
            <Bar dataKey="b2b" name="B2B (Subdealer)" fill="#3b82f6" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
